var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "market-list-form" },
    [
      _c(
        "el-radio-group",
        {
          staticStyle: { "margin-bottom": "30px" },
          attrs: { size: "small" },
          model: {
            value: _vm.activeSetting,
            callback: function ($$v) {
              _vm.activeSetting = $$v
            },
            expression: "activeSetting",
          },
        },
        [
          _c("el-radio-button", { attrs: { label: 1 } }, [_vm._v("内 容")]),
          _vm._v(" "),
          _c("el-radio-button", { attrs: { label: 2 } }, [_vm._v("样 式")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting == 1,
              expression: "activeSetting==1",
            },
          ],
          attrs: { model: _vm.itemInfo, "label-width": "120px" },
        },
        [
          _c("el-form-item", { attrs: { label: "左图片：" } }, [
            _vm.userType === 1
              ? _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "upLoadPicBox",
                        on: {
                          click: function ($event) {
                            return _vm.modalPicTap("1", "logoUrl")
                          },
                        },
                      },
                      [
                        _vm.itemInfo.logoUrl
                          ? _c("div", { staticClass: "pictrue" }, [
                              _c("img", {
                                attrs: { src: _vm.itemInfo.logoUrl },
                              }),
                            ])
                          : _c("div", { staticClass: "upLoad" }, [
                              _c("i", {
                                staticClass: "el-icon-camera cameraIconfont",
                              }),
                            ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.itemInfo.logoUrl
                      ? _c("i", {
                          staticClass: "el-icon-delete",
                          staticStyle: { color: "red", "font-size": "16px" },
                          on: {
                            click: function ($event) {
                              return _vm.removeImg("logoUrl")
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                )
              : _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "el-upload",
                      {
                        staticClass: "avatar-uploader",
                        attrs: {
                          action: "",
                          "show-file-list": false,
                          "http-request": function (options) {
                            return _vm.handleLocalUpload(options, "logoUrl")
                          },
                          "before-upload": _vm.beforeUpload,
                          accept: "image/*",
                        },
                      },
                      [
                        _vm.itemInfo.logoUrl
                          ? _c("img", {
                              staticClass: "avatar",
                              attrs: { src: _vm.itemInfo.logoUrl },
                            })
                          : _c("i", {
                              staticClass: "el-icon-plus avatar-uploader-icon",
                            }),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.itemInfo.logoUrl
                      ? _c("i", {
                          staticClass: "el-icon-delete",
                          staticStyle: {
                            color: "red",
                            "font-size": "20px",
                            "margin-left": "10px",
                            cursor: "pointer",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.removeImg("logoUrl")
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "upload-tip",
                        staticStyle: { "margin-left": "10px" },
                      },
                      [_vm._v("支持jpg、png格式，不超过2MB")]
                    ),
                  ],
                  1
                ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "类型：" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.newEdit,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo, "newEdit", $$v)
                    },
                    expression: "itemInfo.newEdit",
                  },
                },
                _vm._l(_vm.textList, function (item) {
                  return _c(
                    "el-radio",
                    { key: item.key, attrs: { label: item.key } },
                    [_vm._v(_vm._s(item.label))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.itemInfo.newEdit == 1
            ? _c(
                "el-form-item",
                { attrs: { label: "公告标题：" } },
                [
                  _c("el-input", {
                    staticStyle: { "margin-top": "10px" },
                    attrs: { type: "textarea", rows: 4 },
                    on: { blur: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.tipsTitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "tipsTitle", $$v)
                      },
                      expression: "itemInfo.tipsTitle",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.itemInfo.newEdit == 1
            ? _c(
                "el-form-item",
                { attrs: { label: "跳转链接：" } },
                [
                  _c("JumpNative", {
                    staticStyle: { width: "240px" },
                    model: {
                      value: _vm.itemInfo.openUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "openUrl", $$v)
                      },
                      expression: "itemInfo.openUrl",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.itemInfo.newEdit == 2
            ? _c(
                "el-form-item",
                { attrs: { label: "文章选择：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidth ",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleChange(_vm.itemInfo.textType)
                        },
                      },
                      model: {
                        value: _vm.itemInfo.textType,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo, "textType", $$v)
                        },
                        expression: "itemInfo.textType",
                      },
                    },
                    _vm._l(_vm.textSelsected, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.itemInfo.newEdit == 2
            ? _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidth ",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      on: { change: _vm.updateItem },
                      model: {
                        value: _vm.itemInfo.textUrl,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo, "textUrl", $$v)
                        },
                        expression: "itemInfo.textUrl",
                      },
                    },
                    _vm._l(_vm.textSelsectedUrl, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.title, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting == 2,
              expression: "activeSetting==2",
            },
          ],
          attrs: { model: _vm.itemInfo, "label-width": "100px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "是否滚动：" } },
            [
              _c("el-switch", {
                attrs: {
                  "active-value": 1,
                  "active-text": "是",
                  "inactive-text": "否",
                  "inactive-value": 0,
                },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.loop,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "loop", $$v)
                  },
                  expression: "itemInfo.loop",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "背景图片：" } }, [
            _vm.userType === 1
              ? _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "upLoadPicBox",
                        on: {
                          click: function ($event) {
                            return _vm.modalPicTap("1", "bgImg")
                          },
                        },
                      },
                      [
                        _vm.itemInfo.bgImg
                          ? _c("div", { staticClass: "pictrue" }, [
                              _c("img", { attrs: { src: _vm.itemInfo.bgImg } }),
                            ])
                          : _c("div", { staticClass: "upLoad" }, [
                              _c("i", {
                                staticClass: "el-icon-camera cameraIconfont",
                              }),
                            ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.itemInfo.bgImg
                      ? _c("i", {
                          staticClass: "el-icon-delete",
                          staticStyle: { color: "red", "font-size": "16px" },
                          on: {
                            click: function ($event) {
                              return _vm.removeImg("bgImg")
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                )
              : _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "el-upload",
                      {
                        staticClass: "avatar-uploader",
                        attrs: {
                          action: "",
                          "show-file-list": false,
                          "http-request": function (options) {
                            return _vm.handleLocalUpload(options, "bgImg")
                          },
                          "before-upload": _vm.beforeUpload,
                          accept: "image/*",
                        },
                      },
                      [
                        _vm.itemInfo.bgImg
                          ? _c("img", {
                              staticClass: "avatar",
                              attrs: { src: _vm.itemInfo.bgImg },
                            })
                          : _c("i", {
                              staticClass: "el-icon-plus avatar-uploader-icon",
                            }),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.itemInfo.bgImg
                      ? _c("i", {
                          staticClass: "el-icon-delete",
                          staticStyle: {
                            color: "red",
                            "font-size": "20px",
                            "margin-left": "10px",
                            cursor: "pointer",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.removeImg("bgImg")
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "upload-tip",
                        staticStyle: { "margin-left": "10px" },
                      },
                      [_vm._v("支持jpg、png格式，不超过2MB")]
                    ),
                  ],
                  1
                ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "背景颜色：" } },
            [
              _c("el-color-picker", {
                attrs: { "show-alpha": "" },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.bgColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "bgColor", $$v)
                  },
                  expression: "itemInfo.bgColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "边框颜色：" } },
            [
              _c("el-color-picker", {
                attrs: { "show-alpha": "" },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.borderColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "borderColor", $$v)
                  },
                  expression: "itemInfo.borderColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "外框圆角：" } }, [
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("上："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.borderRadius.pt,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.borderRadius, "pt", $$v)
                    },
                    expression: "itemInfo.borderRadius.pt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("下："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.borderRadius.pb,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.borderRadius, "pb", $$v)
                    },
                    expression: "itemInfo.borderRadius.pb",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("左："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.borderRadius.pl,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.borderRadius, "pl", $$v)
                    },
                    expression: "itemInfo.borderRadius.pl",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("右："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.borderRadius.pr,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.borderRadius, "pr", $$v)
                    },
                    expression: "itemInfo.borderRadius.pr",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "文字外间距：" } }, [
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("上："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.textPadding.pt,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.textPadding, "pt", $$v)
                    },
                    expression: "itemInfo.textPadding.pt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("下："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.textPadding.pb,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.textPadding, "pb", $$v)
                    },
                    expression: "itemInfo.textPadding.pb",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("左："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.textPadding.pl,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.textPadding, "pl", $$v)
                    },
                    expression: "itemInfo.textPadding.pl",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("右："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.textPadding.pr,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.textPadding, "pr", $$v)
                    },
                    expression: "itemInfo.textPadding.pr",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "内间距：" } }, [
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("上："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formPadding.pt,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formPadding, "pt", $$v)
                    },
                    expression: "itemInfo.formPadding.pt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("下："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formPadding.pb,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formPadding, "pb", $$v)
                    },
                    expression: "itemInfo.formPadding.pb",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("左："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formPadding.pl,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formPadding, "pl", $$v)
                    },
                    expression: "itemInfo.formPadding.pl",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("右："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formPadding.pr,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formPadding, "pr", $$v)
                    },
                    expression: "itemInfo.formPadding.pr",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "外间距：" } }, [
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("上："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.mt,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "mt", $$v)
                    },
                    expression: "itemInfo.formMargin.mt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("下："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.mb,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "mb", $$v)
                    },
                    expression: "itemInfo.formMargin.mb",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("左："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.ml,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "ml", $$v)
                    },
                    expression: "itemInfo.formMargin.ml",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("右："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.mr,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "mr", $$v)
                    },
                    expression: "itemInfo.formMargin.mr",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }